const _Misc = require("util/Misc");
const _Dater = require("util/Dater");
const _Sort = require("util/Sort");

const Looper = {
    forEach(dataOrAry, fn){
        for(let propName in dataOrAry){
            let propVal = dataOrAry[propName];
            fn(propName, propVal);
        }
    },
    forEach$($items, fn){
        let n = $items.length;
        for(let i = 0; i < n; i++){
            fn($items.eq(i), i);
        }
    },
    array(ary, fn, doClone){
        let n = (ary) ? ary.length : 0;
        for(let i = 0; i < n; i++){
            if(doClone)
                fn(_Misc.cloneObj(ary[i]), i);
            else
                fn(ary[i], i);
        }
    },
    arrayLimit(ary, fn, startIdx, endIdx){
        let n = (ary) ? ary.length : 0;
        n = Math.min(n, endIdx);
        for(let i = startIdx; i < n; i++){
            fn(ary[i], i);
        }
    },
    resetForm($inputs){
        let n = $inputs.length;
        for(let i = 0; i < n; i++){
            let $item = $inputs.eq(i);
            if($item.attr("disabled"))
                continue;
            $item.val("");
            $item.trigger("reset");
        }
    },
    fetchArrayFromFBObj(obj, sortOn, reverse, markName, markValue){
        let ary = [];
        for(let prop in obj){
            let item = obj[prop];
            item.id = prop;
            if(markName)
                item[markName] = markValue;
            if(item.children)
                item.children = Looper.fetchArrayFromFBObj(item.children, sortOn, reverse, markName, markValue);
            ary.push(item);
        }
        if(!sortOn){
            ary.sort(function(a,b){
                return parseInt(a.updated_on) < parseInt(b.updated_on);
            });
        }
        else{
            ary.sort(function(a,b){
                return a[sortOn] < b[sortOn];
            });
        }

        if(reverse)
            ary = ary.reverse();
        return ary;
    },

    parseFBObj(obj, sortOn, reverse, typeName){
        let ary = [];
        for(let prop in obj){
            let item = obj[prop];
            item.id = prop;
            if(typeName)
                item.kind = typeName;
            if(item.children)
                item.children = Looper.fetchArrayFromFBObj(item.children, sortOn, reverse, markName, markValue);
            ary.push(item);
        }
        if(!sortOn){
            _Sort.updated_on(ary);
        }
        else{
            _Sort[sortOn](ary);
        }

        if(reverse)
            ary = ary.reverse();
        return ary;
    },

    updateChildren(list, propsAry, markAsChild){
        Looper.array(list, function(item){
            if(item.children){
                Looper.array(item.children, function(child){
                    Looper.array(propsAry, function(propName){
                        child[propName] = item[propName];
                        if(markAsChild){
                            child.parentId = item.id;
                        }
                    });
                });
            }
        });
    },
    fetchItemByProp(list, propName, propValue){
        if(list && propValue){
            let n = list.length;
            for(let i = 0; i < n; i++){
                let item = list[i];
                let itemVal = item[propName];
                if(typeof itemVal === "string"){
                    if(itemVal.toLowerCase() == propValue.toLowerCase())
                        return item;
                }
                else if(item[propName] == propValue){
                    return item;
                }

                if(item.children){
                    let m = item.children.length;
                    for(let j = 0; j < m; j++){
                        let child = item.children[j];
                        if(child[propName] == propValue)
                            return child;
                    }
                }
            }
        }
        return null;
    },

    replaceOrAddItemInArrayByProp(list, propName, newItem, sortOn, doDelete){
        let listClone = _Misc.cloneAry(list);
        let n = listClone.length;
        let replaced = false;
        for(let i = 0; i < n; i++){
            let item = listClone[i];
            if(item[propName] === newItem[propName]){
                replaced = true;
                if(doDelete){
                    listClone.splice(i, 1);
                    break
                }
                else{
                    if(newItem.recentlyCreated)
                        delete newItem.recentlyCreated;
                    newItem.recentlyUpdated = true;
                    listClone[i] = newItem;
                }
            }
        }
        if(!replaced){
            newItem.recentlyCreated = true;
            listClone.push(newItem);
            _Misc.sort(listClone, sortOn)
        }
        return listClone;
    },

    purify(obj){
        for(let propName in obj){
            let propVal = obj[propName];
            if(!propVal)
                delete obj[propName];
        }
    },

    fetchItemsForDates(list, sd, ed, dateProperty){
        let datedList = [];
        Looper.array(list, function(item){
            if(_Dater.isInRange(sd, ed, item[dateProperty])){
                datedList.push(_Misc.cloneObj(item));
            }
        });
        return datedList;
    },


    fetchBudgetItemsForDates(list, sd, ed, dateProperty){
        let datedList = [];
        Looper.array(list, function(item){
            if(!item.option1){
                if(_Dater.isInRange(sd, ed, item[dateProperty])){
                    datedList.push(_Misc.cloneObj(item));
                }
            }
        });
        return datedList;
    }
};

module.exports = Looper;


// WEBPACK FOOTER //
// ./src/control/util/Looper.js